import classNames from "classnames";
import React from "react";
import { getDateSeparatorString } from "../../utils/timeFormatter";
import styles from "./dateSeparator.css";

interface Props {
  timestamp: number;
}

export const DateSeparator: React.SFC<Props> = ({ timestamp }) => (
  <div className={classNames(styles.container, styles.dashboard)}>
    <div className={styles["event-text"]}>{getDateSeparatorString(timestamp)}</div>
  </div>
);
